import { TypeFormBuilderWithoutUnresolvableLinksResponse } from 'contentful-types'

import { withContentful } from 'src/siteBuilder/renderer/contentful/withContentful'
import { mapSpacer } from 'src/siteBuilder/renderer/contentful/mapSpacer'

// Component
import FormBuilder from './FormBuilder'

const ContentfulFormBuilder = withContentful<TypeFormBuilderWithoutUnresolvableLinksResponse['fields']>(FormBuilder, {
  form: (props) => {
    return { sys: props.fields?.form?.sys, ...props.fields?.form?.fields }
  },
  spacer: mapSpacer,
  customErrorPage: (props) => {
    return props.fields.errorDisplay ? true : false
  },
})

export default ContentfulFormBuilder
